import { passwordGrade } from '../../../../../../util/password-strength';

export class Controller {

    /** @ngInject */
    constructor(AccountsResource, Alert, GroupsResource) {
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.accounts = [];
        this.isLoading = true;

        this.GroupsResource
            .getAllAccountsForCompanyAndGroupAndApplication(this.companyId, this.groupId, this.appId)
            .then(accounts => accounts.map(account => (
                {...account, 
                    passGrade: passwordGrade(account.password), 
                    searchObj: [account.username, account.user.saaspassId, account.user.displayName]
                })))
            .then(accounts => this.accounts = accounts)
            .finally(() => this.isLoading = false)
    }

    save(accountId, password) {
        return this.AccountsResource
            .setPasswordForAccount(this.companyId, this.appId, accountId, password)
            .then(() => this.accounts.find(a => a.id === accountId))
            .then(a => {
                a.password = password;
                a.passGrade = passwordGrade(password);
            })
            .then(() => this.Alert('success', 'company.manage-application.users.manage-passwords.saved'))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/epm-credentials/epm-credentials.controller.js